import React from 'react';
import NotificationDropdown from './NotificationDropdown';
import { useCachedPermissions } from '../hooks/useCachedPermissions';
import styles from './DashboardHeader.module.css';

const DashboardHeader = ({ onShowNotifications, onToggleSidebar }) => {
    const { hasShowNotification } = useCachedPermissions();

    return (
        <header className={styles.dashboardHeader}>
            <div className={styles.headerContent}>
                <div className={styles.headerLeft}>
                    <button 
                        className={styles.menuButton} 
                        onClick={onToggleSidebar}
                        aria-label="Toggle Menu"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    {/* This space can be used for page title or breadcrumbs if needed */}
                </div>
                <div className={styles.headerRight}>
                    {hasShowNotification && (
                        <NotificationDropdown onShowAll={onShowNotifications} />
                    )}
                </div>
            </div>
        </header>
    );
};

export default DashboardHeader;
